export const MUSEME_API_ORIGIN = 'https://api.museme.com'
// export const MUSEME_API_ORIGIN = 'https://dev-api.museme.com'
export const MUSEME_LIVE_ORIGIN = 'https://live.museme.com'
// export const MUSEME_LIVE_HOSTNAME = 'https://live.museme.com'
